// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".VenuePopUp-module-venuePopUp-K8ynd{display:flex;flex-direction:column;gap:16px;padding:10px}.VenuePopUp-module-venueName-1WsMe{font-size:18px;line-height:23px}.VenuePopUp-module-wrapper-2OVPf{display:flex;align-items:flex-end}.VenuePopUp-module-address-1abe6{max-width:200px;margin-inline-end:30px}", ""]);
// Exports
exports.locals = {
	"venuePopUp": "VenuePopUp-module-venuePopUp-K8ynd",
	"venueName": "VenuePopUp-module-venueName-1WsMe",
	"wrapper": "VenuePopUp-module-wrapper-2OVPf",
	"address": "VenuePopUp-module-address-1abe6"
};
module.exports = exports;
